import { Paper, Stack, Typography } from "@mui/material";
import { colors } from "../constants/designTokens";

export default function EmptyState({
  title,
  description,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${colors.border}`,
        bgcolor: colors.surface,
        boxShadow: "0 16px 35px rgba(24,39,75,0.06)",
      }}
    >
      <Stack alignItems="center" spacing={2} sx={{ px: 3, py: 8, textAlign: "center" }}>
        <Typography sx={{ color: colors.text, fontSize: 21, fontWeight: 900 }}>
          {title}
        </Typography>
        <Typography sx={{ color: colors.muted, fontSize: 14, maxWidth: 480 }}>
          {description}
        </Typography>
      </Stack>
    </Paper>
  );
}
